export const getAgentFilterValue = (userdata) => {
    const { isDiamondAirUser, isHubDropUser } = userdata;

    let agent = 'ALL';

    if (isDiamondAirUser && !isHubDropUser) {
        agent = 'DiamondAirBookings';
    } else if (isHubDropUser && !isDiamondAirUser) {
        agent = 'HubDropBookings';
    }

    return agent;
};

export const getAgentDropDownValues = (userdata) => {
    const { isDiamondAirUser, isHubDropUser } = userdata;

    let menu_items = [
        {
            name: 'All Bookings',
            value: 'ALL',
        },
        {
            name: 'Diamond Air Only',
            value: 'DiamondAirBookings',
        },
        {
            name: 'Hub Drop Only',
            value: 'HubDropBookings',
        },
    ];

    if (isDiamondAirUser && !isHubDropUser) {
        menu_items = [
            // {
            //     name: 'Diamond Air Only',
            //     value: 'DiamondAirBookings',
            // },
        ];
    } else if (isHubDropUser && !isDiamondAirUser) {
        menu_items = [
            // {
            //     name: 'Hub Drop Only',
            //     value: 'HubDropBookings',
            // },
        ];
    }

    return menu_items;
};

export const getStatus = (status: number | string) => {
    switch (status) {
        case 'ScheduledNotStarted':
            return 'ScheduledNotStarted';

        case 'ScheduledTimeslotStarted':
            return 'ScheduledTimeslotStarted';

        case 'InProgress':
            return 'InProgress';

        case 'Completed':
            return 'complete';

        case 'IssueOrWarning':
            return 'IssueOrWarning';

        case 'ImmediateActionRequired':
            return 'ImmediateActionRequired';

        case 'Cancelled':
            return 'cancelled';

        default:
            return 'pending';
    }
};

/**
 * Shadow bookings created from a BDO carry the AP5 prefix (e.g. AP5-UAZRH-2FFV),
 * where ordinary bookings use other prefixes (AP10-, AP11-, ...). Matching the
 * whole first segment rather than a bare startsWith keeps AP50-/AP51- from ever
 * being mistaken for one.
 *
 * This is a heuristic on the reference format, not a contract field. Once IN-97
 * puts bdoReference on GetBooking, gate on that instead and delete this.
 */
export const isShadowBookingReference = (bookingReference?: string | null): boolean =>
    (bookingReference ?? '').trim().toUpperCase().split('-')[0] === 'AP5';
